import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, provideZoneChangeDetection, LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';

registerLocaleData(localePt, 'pt-BR');
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app.routing';
import { ComponentsModule } from './components/components.module';
import { AppComponent } from './app.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { ClienteFormService } from './modals/formularios-crud/cliente-form/cliente-form.service';
import { HomeComponent } from './paginas/home/home.component';
import { LoadingComponent } from './shared/loading/loading.component';
import './extensions/array.extension';
import './extensions/router.extension';
import './extensions/string.extension';
import { StorageService } from './services/storage.service';
import { authInterceptor } from './interceptors/auth.interceptor';
import { AutenticacaoService } from './services/autenticacao.service';
import { NgxCurrencyDirective, provideEnvironmentNgxCurrency, NgxCurrencyInputMode } from 'ngx-currency';
import { ModalsModule } from './modals/modals.module';
import { Pipes } from './pipes/pipes.module';
import { FullCalendarModule } from '@fullcalendar/angular';
import { MAT_DATE_LOCALE, DateAdapter, MatNativeDateModule } from '@angular/material/core';
import { BrDateAdapter } from './shared/br-date-adapter';
import { MatSnackBarModule } from '@angular/material/snack-bar';

@NgModule({
  imports: [
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    ComponentsModule,
    ModalsModule,
    RouterModule,
    NgbModule,
    [SweetAlert2Module.forRoot()],
    LoadingComponent,
    Pipes,
    FullCalendarModule,
    MatSnackBarModule,
    MatNativeDateModule,
  ],
  declarations: [
    AppComponent,
    HomeComponent
  ],
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    ClienteFormService,
    StorageService,
    AutenticacaoService,
    provideHttpClient(withInterceptors([authInterceptor])),
    provideEnvironmentNgxCurrency({
      align: 'right',
      allowNegative: false,
      decimal: ',',
      precision: 2,
      prefix: 'R$ ',
      suffix: '',
      thousands: '.',
      nullable: false,
      min: null,
      max: null,
      inputMode: NgxCurrencyInputMode.Financial,
    }),
    { provide: MAT_DATE_LOCALE, useValue: 'pt-br' },
    { provide: DateAdapter, useClass: BrDateAdapter },
    { provide: LOCALE_ID, useValue: 'pt-BR' }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
